module.exports = __webpack_public_path__ + "static/media/collage_6.b2d15012.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/collageGame/collage_6.jpg
// module id = 2260
// module chunks = 0